import React, { memo } from "react";

/**
 * Modal component for selecting video generation quality
 */
const QualityModal = memo(({ isVisible, onSelect, onCancel }) => {
  if (!isVisible) return null;

  return (
    <div className="quality-modal">
      <div className="quality-modal-content">
        <h2>Choose Generation Quality</h2>
        <p>Select the speed and quality of video generation</p>
        <div className="quality-modal-buttons">
          <button onClick={() => onSelect('ultrafast')}>
            Ultra Fast (Lower Quality)
          </button>
          <button onClick={() => onSelect('fast')}>
            Fast (Recommended)
          </button>
          <button onClick={() => onSelect('medium')}>
            Higher Quality (Slower)
          </button>
          <button
            className="cancel-btn"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
});

QualityModal.displayName = 'QualityModal';

export default QualityModal;
